<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
        :method-fetch-data="methods.fetchData"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import {
  appendUserToRegions as updateData,
  getUserRegions as fetchData,
} from "@/api/users";
import { getRegions } from "@/api/regions";
import defaultScheme from "@/api/schemes/usersRegions";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme) => {
  try {
    const { regions } = scheme.properties;

    const response = await getRegions();
    Object.assign(regions, {
      items: response.regions,
      params: { key: "id", label: "name", multiple: true },
    });
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        updateData,
        updateScheme,
        fetchData,
      },
    };
  },
};
</script>
